import { render, staticRenderFns } from "./tongji.vue?vue&type=template&id=7aed5162&scoped=true&"
import script from "./tongji.vue?vue&type=script&lang=js&"
export * from "./tongji.vue?vue&type=script&lang=js&"
import style0 from "./tongji.vue?vue&type=style&index=0&id=7aed5162&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aed5162",
  null
  
)

export default component.exports